<template>
    <b-modal ref="client-card-modal" @ok="clientCardModalOk">
      <template v-slot:modal-header="{}">
        <div>{{ $store.state.localization.data.mainPage.clients.pageLabel }}</div>
      </template>
      <div style="font-size: 13px">
          <b-tabs>
            <MainTab
              ref="main-tab"
            ></MainTab>
            <RolesTab
              v-bind:allRoles="roles"
              ref="roles-tab"
            ></RolesTab>
            <CompaniesTab
              v-bind:allCompanies="companies"
              ref="companies-tab"
            ></CompaniesTab>
        </b-tabs>
      </div>
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button variant="success" style="font-size: 12px" @click="ok()">{{
          $store.state.localization.data.common.table.ok
        }}</b-button>
        <b-button variant="light" style="font-size: 12px" @click="cancel()">{{
          $store.state.localization.data.common.table.cancel
        }}</b-button>
      </template>
    </b-modal>
  </template>
  
  <script>
  import MainTab from "./MainTab.vue";
  import RolesTab from "./RolesTab.vue";
  import CompaniesTab from "./CompaniesTab.vue";
  import { userService } from "../../../services";

  export default {
    name: "CreateClientPage",
    components: {
      MainTab,
      RolesTab,
      CompaniesTab
    },
    data() {
      return {
        roles: [],
        companies: []
      };
    },
    methods: {
      open(roles, companies) {
        this.roles = roles;
        this.companies = companies;

        this.$refs["client-card-modal"].show();
      },
      async clientCardModalOk(event) {
        if (!this.$refs["main-tab"].validate()) {
          event.preventDefault();
          return;
        }

        const mainData = this.$refs["main-tab"].getMainData();
        const roles = this.$refs["roles-tab"].getRoles();
        const companies = this.$refs["companies-tab"].getCompanies();

        const user = {
          isActive: mainData.isActive,
          userName: mainData.userName,
          email: mainData.email,
          password: mainData.password,
          roles: roles,
          companies: companies
        };
        
        const createUserResponse = await userService.createUser(user);

        if (
          createUserResponse.isSuccess &&
          createUserResponse.data &&
          createUserResponse.data.userId != 0
        ) {
          this.$emit("clientCreatedSuccessEvent", user);
        } else {
          this.$emit("clientCreatedFailEvent");
        }
      },
    },
  };
  </script>
  